import { render, staticRenderFns } from "./manual2.vue?vue&type=template&id=2a402bb2&scoped=true"
import script from "./manual2.vue?vue&type=script&lang=js"
export * from "./manual2.vue?vue&type=script&lang=js"
import style0 from "./manual2.vue?vue&type=style&index=0&id=2a402bb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a402bb2",
  null
  
)

export default component.exports